import React from "react";

// Lucide-style basketball icon: outer circle + classic seams
// (vertical, horizontal, and two side arcs). Uses currentColor.
export default function BasketballIcon({ className = "", size = 20, strokeWidth = 2, ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden="true"
      {...props}
    >
      <circle cx="12" cy="12" r="10" />
      <line x1="12" y1="2" x2="12" y2="22" />
      <line x1="2" y1="12" x2="22" y2="12" />
      <path d="M4.93 4.93A10 10 0 0 1 12 12a10 10 0 0 1-7.07 7.07" />
      <path d="M19.07 4.93A10 10 0 0 0 12 12a10 10 0 0 0 7.07 7.07" />
    </svg>
  );
}
